/*
 * TAKEDA CONFIDENTIAL – Highly Restricted: Do not distribute without prior approval
 *
 * © Copyright (2026) Takeda. All Rights Reserved
 */

import axios from 'axios';

import { getBaseUrl } from '../../domain/browser.domain';
import { getTime } from '../../domain/dates/dates.domain';

export const getEnvConfig = () => {
  return axios
    .get<EnvConfig>(`${getBaseUrl()}/config/env-config.json?t=${getTime()}`)
    .then(({ data }) => data)
    .catch(() => {
      throw Error('Error fetching env data');
    });
};

export type EnvConfig = {
  msalClientId: string;
  msalAuthority: string;
  entraAccountsBaseUrl: string;
};
